export default {"src":"/_next/static/media/select_arrow.4c67339d.svg","height":6,"width":12};